import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';
import { FileReaderEvent } from '../../../shared/models/FileReader';
import { AppService } from '../../../app.service';
import { AttachFileDialogComponent } from '../../document-in-library/attach-file-dialog/attach-file-dialog.component';
import { GETModels, PIPImplementAttachmentsVM, PIPImplementAuditTrailVM, PIPImplementImagesVM, PIPImplemetLevelforAsset, PIPStatusVM, PIPSupportProgramLevelsVM } from '../../GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../../GET_NEW_UI/services/document-library.service';
import { ProgramImprovementService } from '../../GET_NEW_UI/services/program-improvement.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { ProductImprovmentAssetViewimageComponent } from './product-improvment-asset-viewimage/product-improvment-asset-viewimage.component';
import { PreferencesService } from '../../preferences/preferences.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-product-improvement-for-asset',
  templateUrl: './product-improvement-for-asset.component.html',
  styleUrls: ['./product-improvement-for-asset.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],

})
export class ProductImprovementForAssetComponent implements OnInit {

  constructor(  private _appService: AppService,public dialog: MatDialog,
    private _route: ActivatedRoute, private _programImprovementService :ProgramImprovementService,
    private _documentLibraryService:DocumentLibraryService, 
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    private readonly _pref: PreferencesService, 
    private _router: Router,) { }

  attachmentList=[]
  modelList:GETModels[]=[]
  PIPStatusList:PIPStatusVM[]=[]
  PIPsupportLevelList:PIPSupportProgramLevelsVM[]=[]

  Selectmodel:number[]=[];
  serialStart:string=""
  serialEnd:string=""
  PIPNumber:string=""
  PIPHeading:string=""
  PIPDescription:string=""
  startDate:Date
  endDate:Date
  pipCompletedDate:Date
  supportProgramAssociateLevel:number=0
  supportProgramNotes:string=""
  selectProgramStatus:number=0
  selectAssetPIPStatus:number=0
  PIPAssetNotes:string=""
  PIPSupportDocList:PIPImplementAttachmentsVM[]=[]

  NewFileName: string = "";
  FilePreview: string = "";
  PIPImplementImageID:number=0

  isSelectAll:boolean=false
  Selectmodel_=[]

  ImplementId:number
  PIPId:number
  PIPImplementId:number
  pipAuditTrailList:PIPImplementAuditTrailVM[]=[]
  ngOnInit() {
    this._appService.setPageTitle('Product Improvement for Asset');
    this.ImplementId = +this._route.snapshot.paramMap.get('ImplementId');
    this.PIPId = +this._route.snapshot.paramMap.get('PIPId');
    this.PIPImplementId = +this._route.snapshot.paramMap.get('Id');
    this.GetPIPDetailsForAsset();
    this.getGETModels();
    this.getPIPStatus();
    this.getPIPSupportLevels();
    this.GetPIPImplementImages();
    this.getPIPAuditTrails()

  }

  getGETModels()
  {
    this._documentLibraryService.GetGETModelList().subscribe(res=>{
    this.modelList=res
    })
  }

  getPIPStatus(){
   this._programImprovementService.getPIPStatus().subscribe(res=>{
   this.PIPStatusList=res
   
   })
  }

  getPIPSupportLevels(){
    this._programImprovementService.getPIPSupportLevel().subscribe(res=>{
      this.PIPsupportLevelList=res
      console.log(this.PIPsupportLevelList)
    })
  }

  GetPIPDetailsForAsset(){
   this._programImprovementService.GetPIPDetailsForAsset(this.ImplementId, this.PIPId).subscribe(res=>{
  console.log(res)
  this.Selectmodel=res.ModelId;
  this. Selectmodel_=res.ModelId
  this.serialStart=res.SerialStart;
  this.serialEnd=res.SerialEnd;
  this.PIPNumber=res.PIPNo;
  this.PIPHeading=res.PIPHeading;
  this.PIPDescription=res.PIPDescription;;
  this.startDate=res.StartDate;
  this.endDate=res.EndDate;
  this.supportProgramAssociateLevel=res.supportProgramLevelId;
  this.supportProgramNotes=res.supportProgramNote;
  this.selectProgramStatus=res.PIPStatusID
  this.selectAssetPIPStatus=res.assetPIPStatus;
  this.PIPAssetNotes=res.assetPIPNotes;
  this.pipCompletedDate=res.completedDate;
  this.PIPSupportDocList=res.PIPSupportDocList;



   })
  }

  AddNewAttachment() {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res != false) {
       // var images_ = (res).split(',');
       // this.FilePreview = images_[1];
       this.FilePreview = res.FilePreview;
this.NewFileName = res.NewFileName;
        //Update
        let param =  new PIPImplementAttachmentsVM();
        param.ImplementID = this.ImplementId;
        param.pipId=this.PIPId;
        param.PIPImplementId=this.PIPImplementId
        param.attachment=this.FilePreview;
        param.FileName=this.NewFileName;
        this._programImprovementService.UpdatePIPImplementAttachment(param).subscribe(res=>{
          if(res== true){
            this._notify.success('Attachment Successfully Added');
            this.GetPIPDetailsForAsset();
            this.getPIPAuditTrails();
            //this.LoadAllDocumentLibraryForImplement();
          }
        })
        
      }

    });
  }

 
  
  ReplaceAttachment( AttachementInfo: PIPImplementAttachmentsVM) {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res != false) {
        
       // var images_ = (res).split(',');
        this.FilePreview = res.FilePreview;
        this.NewFileName = res.NewFileName;
        //Update
        AttachementInfo.ImplementID = this.ImplementId;
        AttachementInfo.pipId=this.PIPId;
        AttachementInfo.attachment=this.FilePreview
        AttachementInfo.PIPImplementId=this.PIPImplementId
        AttachementInfo.FileName=this.NewFileName
        this._programImprovementService.UpdatePIPImplementAttachment(AttachementInfo).subscribe(res=>{
          if(res== true){
            this._notify.success('Attachment Successfully Replaced');
            this.GetPIPDetailsForAsset()
            this.getPIPAuditTrails();
           // this.LoadAllDocumentLibraryForImplement();
          }
        })
        
      }

    });
  }


  openAttachDoc()
  {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: { NewFileName:this.NewFileName,
              FilePreview:this.FilePreview
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res !=false) {
        this.FilePreview=res; 
             
      }
   
    });
  }
  onClickDownloadForm(form) {



    var arrBuffer = this.base64ToArrayBuffer(form.attachment);
    var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
    var link = document.createElement('a');    
    link.href = window.URL.createObjectURL(blob);
    link.download = form.FileName + '.pdf';
    link.click();

    // var newstring = form.attachment_.slice(1);
    // console.log('length ', newstring.length - 1)

    // let _newstring = newstring.substring(0, newstring.length - 1);
    // console.log("newstringnewstringnewstring", _newstring)

    // var arrBuffer = this.base64ToArrayBuffer(form.attachment_);

    // if(form.Extension =='pdf'){
    //   var blob = new Blob([arrBuffer], { type: 'application/pdf' });  
    //   var link = document.createElement('a');    
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = form.FileName + '.pdf';
    //   link.click();
    // }

}

base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

// delete(i) {
//   let array =[];
//   array=this.attachmentList;  
//   array.splice(i,1)  
//   this.attachmentList=array            

//  }

 buildnoFormControl = new FormControl("", [Validators.required]);
 getErrorMessage() {
   return this.buildnoFormControl.hasError("required") ? "You must enter a value" : "";
 }


 selectAll(ev) {
  let  arr=[]
   this.isSelectAll = !this.isSelectAll;
   if(this.isSelectAll){
     for(let i=0; i<this.modelList.length; i++){
       arr.push(this.modelList[i].ID)
     } 
        this.buildnoFormControl.setValue(arr);
   } 
   else{
     this.buildnoFormControl.setValue([]);
   }   
    console.log(this.buildnoFormControl.value);
    this.Selectmodel_=this.buildnoFormControl.value
 }

 
 valueChange(ID: number) {
  console.log(this.Selectmodel_.indexOf(ID));
  if (this.Selectmodel_.indexOf(ID) > -1) {
    const pos = this.Selectmodel_.indexOf(ID);
    this.Selectmodel_.splice(pos, 1);
  } else {
    this.Selectmodel_.push(ID);
  }
  console.log(this.Selectmodel_);
}


//add  PIP implement Images
uploadPhoto(newPhoto: string){
  let model =new PIPImplementImagesVM();
  model.Id=this.PIPImplementImageID;
  model.PIPImpId=this.PIPImplementId
  model.Images=newPhoto;
  this._programImprovementService.AddDeletePIPImplementImages(model).subscribe(res=>{
    if(res=true){
      this._notify.success('Image Successfully Added');
      this.GetPIPImplementImages();
      this.getPIPAuditTrails();
    }
   
    })

}


onSelectPhoto(event: any) {
  if (event.target.files && event.target.files[0]) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (event: any) => {
      const imageUrl = (event.target["result"]);
      //resize photo
      this.compressImage(imageUrl).then((res: string) => {
        // console.log("imageUrl", res)
        if (res) {
         //console.log('res', res)

          //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
          this.uploadPhoto(res.split(',')[1]);
        }
      })
      //this.uploadPhoto(event.target.result.split(',')[1]);
    };
  }
}
private compressImage(src) {
  return new Promise((res, rej) => {
    const img = new Image();




    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');

      let width, height;
      width = img.width;
      height = img.height;

      console.log('width', width)
      console.log('height', height)

      var ratio = height / width; //cal aspect ratio
      let imageWidth = 800;//643
      var new_height = imageWidth * ratio; //calculate new height


      elem.width = imageWidth;
      elem.height = new_height;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, imageWidth, new_height);
      const data = ctx.canvas.toDataURL();
      res(data);
    }
    img.onerror = error => rej(error);
  })
}
//getImages forimplement
PIPimplementImages:PIPImplementImagesVM[]=[]
GetPIPImplementImages(){
  this._programImprovementService.GetPIPImplementImages(this.PIPImplementId).subscribe(res=>{
this.PIPimplementImages=res
  })
  }


  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  
  deleteImage(photo:PIPImplementImagesVM)
  {
    let model =new PIPImplementImagesVM();
    model.Id=photo.Id;
    model.Images=photo.Images;
    model.PIPImpId=photo.PIPImpId
   // model.PIPImpId=this.PIPImplementId
   // model.Images=newPhoto;
    this._programImprovementService.AddDeletePIPImplementImages(model).subscribe(res=>{
      if(res=true){
        this._notify.success('Image Successfully deleted');
        this.GetPIPImplementImages();
        this.getPIPAuditTrails();
      }
     
      })
  }

  addPIPImplementAuditTrail()
  {
    let model=new PIPImplementAuditTrailVM()
    model.PIPImplementId=this.PIPImplementId;
    model.assetPIPStatus=this.selectAssetPIPStatus;
    model.CompletedDate=this.pipCompletedDate;
    model.AssetPIPNote=this.PIPAssetNotes;

    this._programImprovementService.addPIPImplementAuditTrail(model,this.PIPId, this.ImplementId).subscribe(res=>{
      if(res=true){
        this._notify.success(' Successfully Updated');
        this.getPIPAuditTrails()
      }
     
      
      })
  }

  getPIPAuditTrails(){
    this._programImprovementService.getPIPAuditTrails(this.PIPImplementId, this.ImplementId).subscribe(res=>{
     this.pipAuditTrailList=res
    })
  }


  gotoImplementDetailsScreen(){
    //window.open('/implementdetails/' + this.ImplementId, '_blank');
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/implementdetails', this.ImplementId]);
      }else{             
        window.open('/implementdetails/' + this.ImplementId, '_blank');
       
      }
  });

  }

  openViewPhoto(photo: PIPImplementImagesVM){
    const dialogRef = this.dialog.open(ProductImprovmentAssetViewimageComponent, {
      data: {
        
        image: photo.Images,
        Id:photo.Id,
        PIPImplementId:this.PIPImplementId
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      this.GetPIPImplementImages();
    });
      

  }
  
  NavigateToSearch(){
    this._router.navigate(['/implementdetails',this.ImplementId]);
    }
}
